"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'blPrint',
  data: function data() {
    return {
      htmlTitle: 'DOC_BL_JP_SURENDER_PRINT',
      dialogTableVisible2: false,
      blPrintForm: {
        blNo: '',
        bkNoS: '',
        ccOf: '',
        ccItem: '',
        freight: '',
        shipper: '',
        consignee: '',
        notify: '',
        pdFlag: '',
        fmFlag: '',
        originalFlag: '',
        vvl1: '',
        vvl: '',
        por: '',
        pol: '',
        pod: '',
        del: '',
        casgo: '',
        casgo2: '',
        mark: '',
        grossWeight: '',
        cargoSize: '',
        sayEn: '',
        prepaidPlace: '',
        payablePlace: '',
        blNumber: '',
        issuePlace: '',
        contactWay: '',
        etd: '',
        fwdCntCus: '',
        sapCode: '',
        today: '',
        conpanyName: '',
        freeInputArea: '',
        issueDate: '',
        signature: ''
      }
    };
  },
  methods: {
    blPrint: function blPrint() {
      this.$print(this.$refs.print);
    },
    resetBlPrintForm: function resetBlPrintForm() {
      this.blPrintForm = {
        bookingHeadId: '',
        blNo: '',
        bkNoS: '',
        ccOf: '',
        ccItem: '',
        freight: '',
        shipper: '',
        consignee: '',
        notify: '',
        pdFlag: '',
        fmFlag: '',
        originalFlag: '',
        vvl1: '',
        vvl: '',
        por: '',
        pol: '',
        pod: '',
        del: '',
        casgo: '',
        casgo2: '',
        mark: '',
        grossWeight: '',
        cargoSize: '',
        sayEn: '',
        prepaidPlace: '',
        payablePlace: '',
        blNumber: '',
        issuePlace: '',
        contactWay: '',
        etd: '',
        fwdCntCus: '',
        sapCode: '',
        today: '',
        conpanyName: '',
        freeInputArea: '',
        issueDate: '',
        signature: ''
      };
    }
  }
};